// src/menu-items/admin.js
import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import SellIcon from "@mui/icons-material/Sell";
import OutboxIcon from "@mui/icons-material/Outbox";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import StoreIcon from "@mui/icons-material/Store";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import EmailIcon from "@mui/icons-material/Email";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useAuth } from "../hooks/useAuth";
import { hasPermission } from "../utils/permissionUtils";

const AdminMenu = () => {
  const { role } = useAuth();

  const generateAdminMenu = () => {
    const adminMenu = [
      /* Dashboard Menu */
      {
        title: "Dashboard",
        items: [
          {
            path: "/admin/super_admin",
            name: "Dashboard",
            icon: <DashboardIcon />,
          },
        ],
      },
      /* หมวดหมู่สินค้า โรงรับจำนำ */
      hasPermission(role, ["admin", "SuperAdminA", "SuperAdminM"]) && {
        title: "สินค้า",
        items: [
          {
            path: "/admin/all-products-pawn",
            name: "รายการทั้งหมด",
            icon: <Inventory2Icon />,
          },
          {
            path: "/admin/all-products-cars",
            name: "รถทั้งหมด",
            icon: <RequestPageIcon />,
          },
          {
            path: "/admin/all-products-lands",
            name: "ที่ดินทั้งหมด",
            icon: <ShoppingCartIcon />,
          },
          {
            path: "/admin/customer-list",
            name: "รายชื่อลูกค้า",
            icon: <SwapHorizontalCircleIcon />,
          },
          {
            path: "/admin/bin",
            name: "ถังขยะ",
            icon: <AccessTimeFilledIcon />,
          },
        ],
      },
      /* หมวดหมู่รายการ โรงรับจำนำ */
      hasPermission(role, ["admin", "SuperAdminA", "SuperAdminM"]) && {
        title: "จัดการ",
        items: [
          {
            path: "/admin/company",
            name: "ร้าน/บริษัท",
            icon: <SellIcon />,
          },
          {
            path: "/admin/users",
            name: "ผู้ใช้งาน",
            icon: <OutboxIcon />,
          },
          {
            path: "/admin/bill",
            name: "ข้อมูลสำหรับออกบิล",
            icon: <PaidIcon />,
          },
          {
            path: "/admin/permissions",
            name: "สิทธิ์",
            icon: <ContactPageIcon />,
          },
          {
            path: "/admin/package-management",
            name: "จัดการแพ็กเกจ",
            icon: <EmailIcon />,
          },
          {
            path: "/admin/history-log",
            name: "History Log",
            icon: <PeopleAltIcon />,
          },
        ],
      },
      /* หมวดหมู่รายงาน โรงรับจำนำ */
      // hasPermission(role, ["admin", "AdminA", "AdminM"]) && {
      //   title: "รายงาน",
      //   items: [
      //     {
      //       path: "/admin/inventory_pawn",
      //       name: "ทรัพย์คงคลัง",
      //       icon: <StoreIcon />,
      //     },
      //     {
      //       path: "/admin/income_expenses_pawn",
      //       name: "รายรับ-รายจ่าย",
      //       icon: <PriceChangeIcon />,
      //     },
      //     {
      //       path: "/admin/interest_pawn",
      //       name: "ดอกเบี้ย",
      //       icon: <TrendingUpIcon />,
      //     },
      //   ],
      // },
      /* หมวดหมู่นำเข้าข้อมูลย้อนหลัง โรงรับจำนำ */
      hasPermission(role, ["admin", "SuperAdminA", "SuperAdminM"]) && {
        title: "นำเข้าข้อมูลย้อนหลัง",
        items: [
          {
            path: "/admin/import_data_pawn",
            name: "รายการนำเข้า",
            icon: <SummarizeIcon />,
          },
          {
            path: "/admin/import_information_pawn",
            name: "นำเข้าข้อมูลขายฝาก",
            icon: <SellIcon />,
          },
          {
            path: "/admin/import_information_buy_pawn",
            name: "นำเข้าข้อมูลซื้อ",
            icon: <RequestPageIcon />,
          },
          // {
          //   path: "/admin/import_list_pawn",
          //   name: "นำเข้าข้อมูลรายการ",
          //   icon: <OutboxIcon />,
          // },
        ],
      },
    ].filter(Boolean);

    return adminMenu;
  };

  return generateAdminMenu(); // Call the function to get the routes
};

export default AdminMenu;
